module.exports = __webpack_public_path__ + "static/media/icon-empty.94bfa433.svg";